import { render, staticRenderFns } from "./ArticleTilePricelist.vue?vue&type=template&id=598a515a"
import script from "./ArticleTilePricelist.vue?vue&type=script&lang=ts"
export * from "./ArticleTilePricelist.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports